import { useEffect, useState } from 'react'
import { COOKIE_BANNER_KEY, getLocalStorageItem } from 'utils/localStorage'

import { CookieBanner } from './CookieBanner'

export const CookieBannerChecker = () => {
  const [isShowCookieBanner, setIsShowCookieBanner] = useState(false)

  useEffect(() => {
    setIsShowCookieBanner(!getLocalStorageItem<boolean>(COOKIE_BANNER_KEY))
  }, [])

  const handleClick = () => {
    localStorage.setItem(COOKIE_BANNER_KEY, 'true')
    setIsShowCookieBanner(false)
  }

  if (!isShowCookieBanner) {
    return <></>
  }

  return <CookieBanner handleClick={handleClick} />
}
